import { render, staticRenderFns } from "./PIStatusPop.vue?vue&type=template&id=20fed348"
import script from "./PIStatusPop.vue?vue&type=script&lang=js"
export * from "./PIStatusPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports